import { render, staticRenderFns } from "./CamarasInforme.vue?vue&type=template&id=8146b23c&"
import script from "./CamarasInforme.vue?vue&type=script&lang=js&"
export * from "./CamarasInforme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports